import API from '../../utils/Api'
import i18n from '@/plugins/i18n'

const api = new API('game-versions')


const state = {
  list: [],
  loading: false,
  model: {
    name: "",
    type: "",
    demands: [],
    variability: 0,
    min: 0,
    max: 0,
    constant: 0
  }
}

const getters = {
  headers () {
    return [
      {
        text: i18n.t('gameVersions.name'),
        align: 'center',
        value: 'name'
      },
      {
        text: i18n.t('general.actions'),
        align: 'center',
        sortable: false
      }
    ]
  },
  flowEquationDisplayModes () {
    return [
      {
        name: i18n.t('gameVersions.flowEquationDisplayModes.notDisplay'),
        number: 0
      },
      {
        name: i18n.t('gameVersions.flowEquationDisplayModes.alreadyCalculated'),
        number: 1
      },
      {
        name: i18n.t('gameVersions.flowEquationDisplayModes.show'),
        number: 2
      }
    ]
  }
}

const actions = {
  async getOne({ commit }, id) {
    try {
      commit('SET_loading', true)
      let res = await api.get(id)
      commit('SET_loading', false)
      return res.data
    } catch (error) {
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.gameVersions.getOneError') + error.message }, { root: true })
    }
  },
  async getAll({ commit }) {
    try {
      commit('SET_loading', true)
      let res = await api.getAll()
      commit('SET_list', res.data)
      commit('SET_loading', false)
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.gameVersions.getAllError') + error.message }, { root: true })
    }
  },
  async addNew({ commit }, data) {
    try {
      commit('SET_loading', true)
      let res = await api.post(data, '')
      commit('ADD_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.gameVersions.add') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.gameVersions.addError') + error.message }, { root: true })
      return false
    }
  },
  async duplicate({ commit }, data) {
    try {
      commit('SET_loading', true)
      let res = await api.post(data, '/duplicate')
      commit('ADD_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.gameVersions.add') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.gameVersions.addError') + error.message }, { root: true })
      return false
    }
  },
  async update({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "")
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.gameVersions.update') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.gameVersions.updateError') + error.message }, { root: true })
      return false
    }
  },
  async uploadLogo({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.upload(params.id, params.data, 'update-logo')
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: "Le logo a bien été modifié" }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: "Erreur lors de la modification du logo : " + error.message }, { root: true })
      return false
    }
  },
  async delete({ commit }, params) {
    try {
      commit('SET_loading', true)
      await api.deleteMany(params)
      commit('DELETE_list', params)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.gameVersions.delete') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.gameVersions.deleteError') + error.message }, { root: true })
      return false
    }
  }
}

const mutations = {
  DELETE_list(state, toDelete) {
    for (let i = 0; i < toDelete.length; i++) {
      for (let index = 0; index < state.list.length; index++) {
        if (state.list[index]._id === toDelete[i]) {
          state.list.splice(index, 1)
          break
        }
      }
    }
    
  },
  UPDATE_list(state, val) {
    for (let index = 0; index < state.list.length; index++) {
      if (state.list[index]._id === val._id) {
        state.list.splice(index, 1, val)
        break
      }
    }
  },
  ADD_list(state, val) {
    state.list.push(val)
  },
  SET_list(state, val) {
    state.list = val
  },
  SET_loading(state, val) {
    state.loading = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}